import './FleetPartnership.scss';
import React from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function FleetPartnerShip({ fields }) {
  return (
    <div className={'container fleet-partner-ship'}>
      <div className={'wrapper'} data-aos="fade-up">
        <div className={'image'}>
          <Image field={fields?.image} alt="img" />
        </div>
        <div className={'card'}>
          <div className={'card_inner'}>
            <div>
              <h3 className={'card_title'}>{fields?.title?.value}</h3>
              <p className={'card_text'}>{fields?.desc?.value}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
